import GrowthEpicClient from 'bundles/epic/clients/Growth';
import { useIntl } from 'bundles/page/lib/useIntl';

import _t from 'i18n!nls/xdp';

function useDurationLabels(totalHours: number, withFlexibleSchedule: boolean) {
  const intl = useIntl();
  totalHours = Math.max(Math.round(totalHours), 1);
  const totalWeeks = Math.round(totalHours / 10);
  const totalMonths = Math.round(totalHours / 20) / 2;

  const variant = GrowthEpicClient.preview('learningHoursVariant');
  if (!variant || variant === 'CONTROL') return null;

  if (withFlexibleSchedule) {
    return {
      title: _t('Flexible schedule'),
      subtitle:
        totalHours < 10
          ? intl.formatMessage(_t('{totalHours} {totalHours, plural, =1 {hour} other {hours}} to complete'), {
              totalHours,
            })
          : totalHours < 80
          ? intl.formatMessage(_t('{totalWeeks} {totalWeeks, plural, =1 {week} other {weeks}} at 10 hours a week'), {
              totalWeeks,
            })
          : intl.formatMessage(
              _t('{totalMonths} {totalMonths, plural, =1 {month} other {months}} at 10 hours a week'),
              { totalMonths }
            ),
    };
  } else {
    if (totalHours < 10) {
      return {
        title: intl.formatMessage(_t('{totalHours} {totalHours, plural, =1 {hour} other {hours}} to complete'), {
          totalHours,
        }),
        subtitle: false,
      };
    } else {
      return {
        title:
          totalHours < 80
            ? intl.formatMessage(_t('{totalWeeks} {totalWeeks, plural, =1 {week} other {weeks}} to complete'), {
                totalWeeks,
              })
            : intl.formatMessage(_t('{totalMonths} {totalMonths, plural, =1 {month} other {months}} to complete'), {
                totalMonths,
              }),

        subtitle: _t('at 10 hours a week'),
      };
    }
  }
}

export { useDurationLabels };
